// src/pages/OAuthCallback.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function OAuthCallback() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const data = {
      type: "oauth_callback",
      code: params.get("code"),
      state: params.get("state"),
      error: params.get("error"),
      error_description: params.get("error_description"),
    };

    if (window.opener) {
      // Send message to the parent window that opened this popup
      window.opener.postMessage(data, window.location.origin);
      // Small delay then close the popup
      setTimeout(() => window.close(), 100);
    } else {
      console.log("OAuth Callback data:", data);
      // Optional: handle direct redirect if not opened as a popup
    }
  }, [location]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', gap: '16px' }}>
      <div className="loading-spinner" style={{ width: '40px', height: '40px', border: '4px solid #f3f3f3', borderTop: '4px solid #3498db', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
      <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      <p style={{ fontFamily: 'sans-serif', color: '#666' }}>Completing sign in...</p>
    </div>
  );
}
